import { createContext, useContext, type ReactNode, type FC } from 'react';

type HomePageContextType = {
    isBot: boolean;
    isDesktop: boolean;
    isMobile: boolean;
    isTablet: boolean;
    isLoggedInUser: boolean;
    userType: string;
    isMwSearchBarVariant?: boolean;
    isContentPlacementsTestVariant?: boolean;
    isTopDisplayAdEnabled?: boolean;
    isBottomDisplayAdEnabled?: boolean;
};

export const HomePageContext = createContext<HomePageContextType>({
    isBot: false,
    isDesktop: false,
    isMobile: false,
    isTablet: false,
    isLoggedInUser: false,
    userType: '',
    isMwSearchBarVariant: false,
    isContentPlacementsTestVariant: false,
    isTopDisplayAdEnabled: false,
    isBottomDisplayAdEnabled: false,
});

type ServerVarsProviderProps = {
    children: ReactNode;
} & Required<HomePageContextType>;

export const useHomePageContext = (): HomePageContextType => {
    const context = useContext(HomePageContext);
    if (!context) {
        throw new Error('useHomePageContext must be used within a HomePageContextProvider');
    }
    return context;
};

export const HomePageContextProvider: FC<ServerVarsProviderProps> = ({
    children,
    isBot,
    isDesktop,
    isMobile,
    isTablet,
    isLoggedInUser,
    userType,
    isMwSearchBarVariant,
    isContentPlacementsTestVariant,
    isTopDisplayAdEnabled,
    isBottomDisplayAdEnabled,
}) => {
    return (
        <HomePageContext.Provider
            value={{
                isBot,
                isMobile,
                isTablet,
                isDesktop,
                isLoggedInUser,
                userType,
                isMwSearchBarVariant,
                isContentPlacementsTestVariant,
                isTopDisplayAdEnabled,
                isBottomDisplayAdEnabled,
            }}
        >
            {children}
        </HomePageContext.Provider>
    );
};
